import { defaultParamsForNav } from '@/pages/ipe/workbench/constants/ipeWorkflowStorage';

/**
 * 合并模板步骤默认参数、行级覆盖（stepOverrides[navId]）。
 */
export function resolveStepParams(step, row) {
  const navId = step?.navId;
  const base =
    step?.params && typeof step.params === 'object' && !Array.isArray(step.params)
      ? { ...defaultParamsForNav(navId), ...step.params }
      : { ...defaultParamsForNav(navId) };
  const rowOv = row?.stepOverrides?.[navId];
  if (rowOv && typeof rowOv === 'object' && !Array.isArray(rowOv)) {
    return { ...base, ...rowOv };
  }
  return base;
}

/** 从模板步骤列表中提取可覆盖的 navId（POD 设计模板、标题等） */
export function overridableNavIdsFromTemplate(template) {
  const ids = new Set();
  (template?.steps || []).forEach((s) => {
    if (['podProductDesign', 'titles', 'smartCutout', 'imageCrop', 'imageEnhance', 'platformListing'].includes(s.navId)) {
      ids.add(s.navId);
    }
  });
  return [...ids];
}
